import type * as React from 'react';

function SvgInfo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.5 13.5C8.28793 13.5 9.06815 13.3448 9.7961 13.0433C10.5241 12.7417 11.1855 12.2998 11.7426 11.7426C12.2998 11.1855 12.7417 10.5241 13.0433 9.7961C13.3448 9.06815 13.5 8.28793 13.5 7.5C13.5 6.71207 13.3448 5.93185 13.0433 5.2039C12.7417 4.47594 12.2998 3.81451 11.7426 3.25736C11.1855 2.70021 10.5241 2.25825 9.7961 1.95672C9.06815 1.65519 8.28793 1.5 7.5 1.5C5.9087 1.5 4.38258 2.13214 3.25736 3.25736C2.13214 4.38258 1.5 5.9087 1.5 7.5C1.5 9.0913 2.13214 10.6174 3.25736 11.7426C4.38258 12.8679 5.9087 13.5 7.5 13.5ZM7.5 15C3.35775 15 0 11.6422 0 7.5C0 3.35775 3.35775 0 7.5 0C11.6422 0 15 3.35775 15 7.5C15 11.6422 11.6422 15 7.5 15ZM6.75 6.75V11.25H8.25V6.75H6.75ZM6.75 3.75H8.25V5.25H6.75V3.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgInfo;
